import { render, staticRenderFns } from "./BtnInserirFaseContrato.vue?vue&type=template&id=ab4dc358&"
import script from "./BtnInserirFaseContrato.vue?vue&type=script&lang=js&"
export * from "./BtnInserirFaseContrato.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports